<template>
    <!-- <div v-if="pauseFlag === 0" class="pause hidden"></div>
    <div v-else class="pause fixed w-full h-full bg-theme-white z-50 ">
        <div class="h-12 bg-theme-green flex">
            <img class="w-48 px-4" :src="img_common_path + ichioshi_logo">
        </div>
        <div class="h-120 flex justify-center items-center">
            <figure><img class="h-20" :src="img_common_path + ichioshikun_solo"></figure>
            <p class="text-lg ml-4">こちらのページは、ただいま準備中です。<br>{{ pause_text }}</p>
        </div>
    </div> -->
    <HomeHeader></HomeHeader>
    <div class="home relative h-max">
        <HomeCategoryList></HomeCategoryList>
        <!-- <HomeMovieList></HomeMovieList> -->
        <!-- <HomeGuide></HomeGuide> -->
    </div>
</template>

<script>
import HomeHeader from '@/components/HomeHeader.vue';
import HomeCategoryList from '@/components/HomeCategoryList.vue';
// import HomeMovieList from '@/components/HomeMovieList.vue';
// import HomeGuide from '@/components/HomeGuide.vue';
import { ref } from 'vue';
import axios from 'axios';


export default {
    name: 'SmartSchool',
    components: {
        HomeHeader,
        HomeCategoryList,
        // HomeMovieList,
        // HomeGuide,
        // Footer
    },
    setup() {
        const img_common_path = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/common/"
        const ichioshi_logo = "ichioshi_logo.svg"
        const ichioshikun_solo = "ichioshi-kun_solo.png"
        const pauseFlag = ref()
        const pause_text = ref()
        async function getData() {
            const console_json = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/json/console.json"
            let data = await axios.get(console_json)
            // console.log(data)
            // pauseFlag.value = data.data[0].pause
            pauseFlag.value = 0
            pause_text.value = data.data[0].pause_text
            // console.log(pauseFlag)
        }
        getData()
        return {
            pauseFlag,
            pause_text,
            img_common_path,
            ichioshi_logo,
            ichioshikun_solo,
            getData
        }
    }
};
</script>